import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button } from 'seagull/components/Button';
import { Card } from 'seagull/components/Card';
import { Column } from 'seagull/components/Layout';
import { ProgressBar } from 'seagull/components/ProgressBar';
import { Typography } from 'seagull/components/Typography';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { tasksStore } from '../tasksStore';
import { useRelationshipPdfCardEvents } from './hooks/useRelationshipPdfCardEvents';
export const GetRelationshipPdfTaskCardTID = (parentTestId)=>getTestIds(parentTestId);
export const RelationshipPdfTaskCard = (param)=>{
    let { task, testId } = param;
    const { t: texts } = useLocaleKeys('tasksDrawer');
    const { browser: { openNewTab } } = useIoContext();
    const { RelationshipPdfTaskCardTestIds } = useMemo(()=>GetRelationshipPdfTaskCardTID(testId), [
        testId
    ]);
    useRelationshipPdfCardEvents(task.jobId);
    if (task.status === 'ready' && task.downloadUrl != null) {
        const downloadUrl = task.downloadUrl;
        return /*#__PURE__*/ _jsx(Card, {
            testId: RelationshipPdfTaskCardTestIds.Root(),
            bi: {
                name: 'relationship_pdf_task_card_ready'
            },
            children: /*#__PURE__*/ _jsxs(Column, {
                gap: 8,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: RelationshipPdfTaskCardTestIds.Title(),
                        children: task.agreementName
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        testId: RelationshipPdfTaskCardTestIds.OpenButton(),
                        bi: {
                            name: 'open_relationship_pdf'
                        },
                        onClick: ()=>{
                            openNewTab(downloadUrl);
                            tasksStore.removeTask(task.jobId);
                        },
                        children: texts.relationshipPdf.open()
                    })
                ]
            })
        });
    }
    if (task.status === 'failed') {
        return /*#__PURE__*/ _jsx(Card, {
            testId: RelationshipPdfTaskCardTestIds.Root(),
            bi: {
                name: 'relationship_pdf_task_card_failed'
            },
            children: /*#__PURE__*/ _jsxs(Column, {
                gap: 8,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: RelationshipPdfTaskCardTestIds.Title(),
                        children: texts.relationshipPdf.failedTitle({
                            name: task.agreementName
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        testId: RelationshipPdfTaskCardTestIds.DismissButton(),
                        bi: {
                            name: 'dismiss_relationship_pdf'
                        },
                        onClick: ()=>tasksStore.removeTask(task.jobId),
                        children: texts.relationshipPdf.dismiss()
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ _jsx(Card, {
        testId: RelationshipPdfTaskCardTestIds.Root(),
        bi: {
            name: 'relationship_pdf_task_card_progress'
        },
        children: /*#__PURE__*/ _jsxs(Column, {
            gap: 8,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    testId: RelationshipPdfTaskCardTestIds.Title(),
                    children: texts.relationshipPdf.generating({
                        name: task.agreementName
                    })
                }),
                /*#__PURE__*/ _jsx(ProgressBar, {
                    completed: task.progress,
                    total: 100
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    testId: RelationshipPdfTaskCardTestIds.Progress(),
                    children: texts.common.percent({
                        value: task.progress
                    })
                })
            ]
        })
    });
};
